(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tw-lp-benefits-bento"] && !Shopify.designMode) return;
  try {
    
  /**
   * Mobile carousel arrows for the benefits grid: scroll by one card and
   * disable the arrows at either end of the track.
   * @param {HTMLElement} root - Section root.
   */
  const initBentoCarousel = (root) => {
    const track = root.querySelector('[data-bento-track]');
    const controls = Array.from(root.querySelectorAll('[data-bento-direction]'));

    if (!track || controls.length === 0) {
      return;
    }

    const getStep = () => {
      const card = track.firstElementChild;

      if (!card) {
        return track.clientWidth;
      }

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

      return card.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 1;

      controls.forEach((control) => {
        const isPrevious = control.dataset.bentoDirection === 'previous';

        control.disabled = isPrevious
          ? track.scrollLeft <= 0
          : track.scrollLeft >= maxScroll;
      });
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const direction = control.dataset.bentoDirection === 'previous' ? -1 : 1;

        track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  document.querySelectorAll('[data-tw-lp-bento]').forEach(initBentoCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tw-lp-bento]').forEach(initBentoCarousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-lp-buy-box"] && !Shopify.designMode) return;
  try {
    
  /**
   * Buy box plan toggle. The mobile sticky bar stays on screen.
   * All plan specific copy lives in data attributes:
   * - [data-plan] buttons switch the active plan.
   * - [data-plan-text] elements swap their text from
   *   data-plan-subscription / data-plan-once.
   * - [data-plan-href] links swap their href from
   *   data-plan-subscription-href / data-plan-once-href.
   * - [data-plan-compare] is shown for subscription only.
   */
  const initBuyBox = (root) => {
    const planButtons = Array.from(root.querySelectorAll('[data-plan]'));
    const planTexts = Array.from(root.querySelectorAll('[data-plan-text]'));
    const planLinks = Array.from(root.querySelectorAll('[data-plan-href]'));
    const compare = root.querySelector('[data-plan-compare]');
    const sticky = root.querySelector('[data-plan-sticky]');

    if (sticky) {
      document
        .querySelectorAll(
          `body > [data-plan-sticky][data-sticky-owner="${sticky.dataset.stickyOwner}"]`,
        )
        .forEach((node) => node.remove());

      document.body.appendChild(sticky);
    }

    /**
     * Applies the selected plan to every plan dependent element.
     * @param {string} plan - "subscription" or "once".
     */
    const renderPlan = (plan) => {
      const isSubscription = plan === 'subscription';
      const key = isSubscription ? 'planSubscription' : 'planOnce';
      const hrefKey = isSubscription ? 'planSubscriptionHref' : 'planOnceHref';

      planButtons.forEach((button) => {
        const isActive = button.dataset.plan === plan;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      planTexts.forEach((element) => {
        const text = element.dataset[key];

        if (text === undefined) {
          return;
        }

        element.textContent = text;
      });

      planLinks.forEach((link) => {
        const href = link.dataset[hrefKey];

        if (!href) {
          return;
        }

        link.setAttribute('href', href);
      });

      if (compare) {
        compare.classList.toggle('is-hidden', !isSubscription);
      }
    };

    planButtons.forEach((button) => {
      button.addEventListener('click', () => renderPlan(button.dataset.plan));
    });
  };

  document.querySelectorAll('[data-tw-lp-buy]').forEach(initBuyBox);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tw-lp-buy]').forEach(initBuyBox);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-lp-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Review carousel: "read more / read less" toggles and a scroll
   * progress bar that mirrors how far the rail has been scrolled.
   * @param {HTMLElement} root - Section root.
   */
  const initPhotoReviews = (root) => {
    root.querySelectorAll('[data-review-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const copy = button.closest('[data-review-copy]');

        if (!copy) {
          return;
        }

        const isExpanded = copy.classList.toggle('is-expanded');

        copy.querySelectorAll('[data-review-toggle]').forEach((toggle) => {
          toggle.setAttribute('aria-expanded', String(isExpanded));
        });
      });
    });

    const rail = root.querySelector('[data-reviews-rail]');
    const progress = root.querySelector('[data-reviews-progress]');

    if (!rail || !progress) {
      return;
    }

    const updateProgress = () => {
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const visibleRatio = rail.clientWidth / rail.scrollWidth;
      const scrolledRatio = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
      const width = visibleRatio + (1 - visibleRatio) * scrolledRatio;

      progress.style.width = `${Math.min(width, 1) * 100}%`;
    };

    rail.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  };

  document.querySelectorAll('[data-tw-lp-photo-reviews]').forEach(initPhotoReviews);

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-tw-lp-photo-reviews]')
      .forEach(initPhotoReviews);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-lp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  /**
   * Pins the bar to the document body so it stays on the viewport,
   * then smooth scrolls the button to its in-page target.
   * @param {HTMLElement} root - Section root.
   */
  const initStickyCta = (root) => {
    const bar = root.querySelector('[data-sticky-bar]');

    if (!bar) {
      return;
    }

    document
      .querySelectorAll(
        `body > [data-sticky-bar][data-sticky-owner="${bar.dataset.stickyOwner}"]`,
      )
      .forEach((node) => node.remove());

    document.body.appendChild(bar);

    const target = document.getElementById(bar.dataset.stickyTarget);
    const link = bar.querySelector('[data-sticky-link]');

    if (!link || !target) {
      return;
    }

    link.addEventListener('click', (event) => {
      if (link.getAttribute('href') !== `#${target.id}`) {
        return;
      }

      event.preventDefault();

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches;

      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  };

  document.querySelectorAll('[data-tw-lp-sticky-cta]').forEach(initStickyCta);

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-tw-lp-sticky-cta]')
      .forEach(initStickyCta);
  });

  } catch(e) { console.error(e); }
})();
})();
